export default {
  ATLANTA_GA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 271,
        truckAndMovers: 670,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 268,
        truckAndMovers: 495,
      },
    },
    HOME: {
      '2BR+': {
        movers: 280,
        truckAndMovers: 864,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 272,
        truckAndMovers: 504,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 336,
        truckAndMovers: 668,
      },
    },
  },
  GA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 271,
        truckAndMovers: 670,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 268,
        truckAndMovers: 495,
      },
    },
    HOME: {
      '2BR+': {
        movers: 280,
        truckAndMovers: 864,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 272,
        truckAndMovers: 504,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 336,
        truckAndMovers: 668,
      },
    },
  },
  AUSTIN_TX: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 275,
        truckAndMovers: 633,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 274,
        truckAndMovers: 481,
      },
    },
    HOME: {
      '2BR+': {
        movers: 288,
        truckAndMovers: 807,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 292,
        truckAndMovers: 464,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 276,
        truckAndMovers: 468,
      },
    },
  },
  TX: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 275,
        truckAndMovers: 633,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 274,
        truckAndMovers: 481,
      },
    },
    HOME: {
      '2BR+': {
        movers: 288,
        truckAndMovers: 807,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 292,
        truckAndMovers: 464,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 276,
        truckAndMovers: 468,
      },
    },
  },
  BALTIMORE_MD: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 394,
        truckAndMovers: 732,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 254,
        truckAndMovers: 616,
      },
    },
    HOME: {
      '2BR+': {
        movers: 434,
        truckAndMovers: 810,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 337,
        truckAndMovers: 468,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 272,
        truckAndMovers: 643,
      },
    },
  },
  MD: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 394,
        truckAndMovers: 732,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 254,
        truckAndMovers: 616,
      },
    },
    HOME: {
      '2BR+': {
        movers: 434,
        truckAndMovers: 810,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 337,
        truckAndMovers: 468,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 272,
        truckAndMovers: 643,
      },
    },
  },
  BIRMINGHAM_AL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 417,
        truckAndMovers: 673,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 269,
        truckAndMovers: 505,
      },
    },
    HOME: {
      '2BR+': {
        movers: 273,
        truckAndMovers: 797,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 268,
        truckAndMovers: 521,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 411,
        truckAndMovers: 680,
      },
    },
  },
  AL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 417,
        truckAndMovers: 673,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 269,
        truckAndMovers: 505,
      },
    },
    HOME: {
      '2BR+': {
        movers: 273,
        truckAndMovers: 797,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 268,
        truckAndMovers: 521,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 411,
        truckAndMovers: 680,
      },
    },
  },
  BOSTON_MA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 417,
        truckAndMovers: 938,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 328,
        truckAndMovers: 662,
      },
    },
    HOME: {
      '2BR+': {
        movers: 288,
        truckAndMovers: 796,
      },
      'Few items': {
        movers: 258,
      },
      'Studio - 1BR': {
        movers: 516,
        truckAndMovers: 516,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 258,
        truckAndMovers: 663,
      },
    },
  },
  MA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 417,
        truckAndMovers: 938,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 328,
        truckAndMovers: 662,
      },
    },
    HOME: {
      '2BR+': {
        movers: 288,
        truckAndMovers: 796,
      },
      'Few items': {
        movers: 258,
      },
      'Studio - 1BR': {
        movers: 516,
        truckAndMovers: 516,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 258,
        truckAndMovers: 663,
      },
    },
  },
  CHARLOTTE_NC: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 229,
        truckAndMovers: 632,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 236,
        truckAndMovers: 578,
      },
    },
    HOME: {
      '2BR+': {
        movers: 255,
        truckAndMovers: 795,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 250,
        truckAndMovers: 473,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 257,
        truckAndMovers: 658,
      },
    },
  },
  NC: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 229,
        truckAndMovers: 632,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 236,
        truckAndMovers: 578,
      },
    },
    HOME: {
      '2BR+': {
        movers: 255,
        truckAndMovers: 795,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 250,
        truckAndMovers: 473,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 257,
        truckAndMovers: 658,
      },
    },
  },
  CHATTANOOGA_TN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 297,
        truckAndMovers: 636,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 248,
        truckAndMovers: 442,
      },
    },
    HOME: {
      '2BR+': {
        movers: 283,
        truckAndMovers: 780,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 232,
        truckAndMovers: 610,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 289,
        truckAndMovers: 626,
      },
    },
  },
  TN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 297,
        truckAndMovers: 636,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 248,
        truckAndMovers: 442,
      },
    },
    HOME: {
      '2BR+': {
        movers: 283,
        truckAndMovers: 780,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 232,
        truckAndMovers: 610,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 289,
        truckAndMovers: 626,
      },
    },
  },
  CHICAGO_IL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 370,
        truckAndMovers: 683,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 257,
        truckAndMovers: 631,
      },
    },
    HOME: {
      '2BR+': {
        movers: 260,
        truckAndMovers: 725,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 259,
        truckAndMovers: 465,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 251,
        truckAndMovers: 594,
      },
    },
  },
  IL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 370,
        truckAndMovers: 683,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 257,
        truckAndMovers: 631,
      },
    },
    HOME: {
      '2BR+': {
        movers: 260,
        truckAndMovers: 725,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 259,
        truckAndMovers: 465,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 251,
        truckAndMovers: 594,
      },
    },
  },
  CINCINNATI_OH: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 537,
        truckAndMovers: 827,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 507,
      },
      'Studio - 1BR': {
        movers: 333,
        truckAndMovers: 600,
      },
    },
    HOME: {
      '2BR+': {
        movers: 336,
        truckAndMovers: 846,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 676,
      },
      'Studio - 1BR': {
        movers: 716,
        truckAndMovers: 676,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 537,
        truckAndMovers: 722,
      },
    },
  },
  OH: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 537,
        truckAndMovers: 827,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 507,
      },
      'Studio - 1BR': {
        movers: 333,
        truckAndMovers: 600,
      },
    },
    HOME: {
      '2BR+': {
        movers: 336,
        truckAndMovers: 846,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 676,
      },
      'Studio - 1BR': {
        movers: 716,
        truckAndMovers: 676,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 537,
        truckAndMovers: 722,
      },
    },
  },
  CLEVELAND_OH: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 329,
        truckAndMovers: 829,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 329,
        truckAndMovers: 595,
      },
    },
    HOME: {
      '2BR+': {
        movers: 293,
        truckAndMovers: 856,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 597,
      },
      'Studio - 1BR': {
        movers: 361,
        truckAndMovers: 548,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 419,
        truckAndMovers: 576,
      },
    },
  },
  'COLORADO SPRINGS_CO': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 258,
        truckAndMovers: 696,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 387,
        truckAndMovers: 845,
      },
    },
    HOME: {
      '2BR+': {
        movers: 351,
        truckAndMovers: 829,
      },
      'Studio - 1BR': {
        movers: 301,
        truckAndMovers: 556,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 516,
        truckAndMovers: 477,
      },
    },
  },
  CO: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 258,
        truckAndMovers: 696,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 387,
        truckAndMovers: 845,
      },
    },
    HOME: {
      '2BR+': {
        movers: 351,
        truckAndMovers: 829,
      },
      'Studio - 1BR': {
        movers: 301,
        truckAndMovers: 556,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 516,
        truckAndMovers: 477,
      },
    },
  },
  COLUMBUS_OH: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 282,
        truckAndMovers: 702,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 280,
        truckAndMovers: 497,
      },
    },
    HOME: {
      '2BR+': {
        movers: 285,
        truckAndMovers: 818,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 248,
        truckAndMovers: 513,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 436,
        truckAndMovers: 525,
      },
    },
  },
  'DALLAS-FORT-WORTH_TX': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 252,
        truckAndMovers: 631,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 246,
        truckAndMovers: 582,
      },
    },
    HOME: {
      '2BR+': {
        movers: 253,
        truckAndMovers: 768,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 238,
        truckAndMovers: 462,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 236,
        truckAndMovers: 603,
      },
    },
  },
  DENVER_CO: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 291,
        truckAndMovers: 717,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 321,
        truckAndMovers: 544,
      },
    },
    HOME: {
      '2BR+': {
        movers: 320,
        truckAndMovers: 917,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 293,
        truckAndMovers: 558,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 322,
        truckAndMovers: 716,
      },
    },
  },
  DETROIT_MI: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 349,
        truckAndMovers: 737,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 273,
        truckAndMovers: 516,
      },
    },
    HOME: {
      '2BR+': {
        movers: 290,
        truckAndMovers: 846,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 257,
        truckAndMovers: 521,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 597,
        truckAndMovers: 683,
      },
    },
  },
  MI: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 349,
        truckAndMovers: 737,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 273,
        truckAndMovers: 516,
      },
    },
    HOME: {
      '2BR+': {
        movers: 290,
        truckAndMovers: 846,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 257,
        truckAndMovers: 521,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 597,
        truckAndMovers: 683,
      },
    },
  },
  HOUSTON_TX: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 224,
        truckAndMovers: 576,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 227,
        truckAndMovers: 560,
      },
    },
    HOME: {
      '2BR+': {
        movers: 209,
        truckAndMovers: 713,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 217,
        truckAndMovers: 418,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 232,
        truckAndMovers: 608,
      },
    },
  },
  INDIANAPOLIS_IN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 321,
        truckAndMovers: 684,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 276,
        truckAndMovers: 498,
      },
    },
    HOME: {
      '2BR+': {
        movers: 306,
        truckAndMovers: 817,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 323,
        truckAndMovers: 495,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 508,
        truckAndMovers: 697,
      },
    },
  },
  IN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 321,
        truckAndMovers: 684,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 276,
        truckAndMovers: 498,
      },
    },
    HOME: {
      '2BR+': {
        movers: 306,
        truckAndMovers: 817,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 323,
        truckAndMovers: 495,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 508,
        truckAndMovers: 697,
      },
    },
  },
  JACKSONVILLE_FL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 276,
        truckAndMovers: 682,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 311,
        truckAndMovers: 499,
      },
    },
    HOME: {
      '2BR+': {
        movers: 303,
        truckAndMovers: 798,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 277,
        truckAndMovers: 546,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 238,
        truckAndMovers: 673,
      },
    },
  },
  FL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 276,
        truckAndMovers: 682,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 311,
        truckAndMovers: 499,
      },
    },
    HOME: {
      '2BR+': {
        movers: 303,
        truckAndMovers: 798,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 277,
        truckAndMovers: 546,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 238,
        truckAndMovers: 673,
      },
    },
  },
  'KANSAS CITY_MO': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 360,
        truckAndMovers: 647,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 261,
        truckAndMovers: 470,
      },
    },
    HOME: {
      '2BR+': {
        movers: 259,
        truckAndMovers: 779,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 294,
        truckAndMovers: 463,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 327,
        truckAndMovers: 674,
      },
    },
  },
  MO: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 360,
        truckAndMovers: 647,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 261,
        truckAndMovers: 470,
      },
    },
    HOME: {
      '2BR+': {
        movers: 259,
        truckAndMovers: 779,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 294,
        truckAndMovers: 463,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 327,
        truckAndMovers: 674,
      },
    },
  },
  KNOXVILLE_TN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 256,
        truckAndMovers: 683,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 253,
        truckAndMovers: 455,
      },
    },
    HOME: {
      '2BR+': {
        movers: 253,
        truckAndMovers: 830,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 270,
        truckAndMovers: 443,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 426,
        truckAndMovers: 667,
      },
    },
  },
  'LAS VEGAS_NV': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 220,
        truckAndMovers: 613,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 207,
        truckAndMovers: 410,
      },
    },
    HOME: {
      '2BR+': {
        movers: 224,
        truckAndMovers: 709,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 244,
        truckAndMovers: 421,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 412,
        truckAndMovers: 613,
      },
    },
  },
  NV: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 220,
        truckAndMovers: 613,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 207,
        truckAndMovers: 410,
      },
    },
    HOME: {
      '2BR+': {
        movers: 224,
        truckAndMovers: 709,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 244,
        truckAndMovers: 421,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 412,
        truckAndMovers: 613,
      },
    },
  },
  'LOS ANGELES_CA': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 219,
        truckAndMovers: 755,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 253,
        truckAndMovers: 559,
      },
    },
    HOME: {
      '2BR+': {
        movers: 207,
        truckAndMovers: 667,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 312,
        truckAndMovers: 444,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 297,
        truckAndMovers: 577,
      },
    },
  },
  CA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 219,
        truckAndMovers: 755,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 253,
        truckAndMovers: 559,
      },
    },
    HOME: {
      '2BR+': {
        movers: 207,
        truckAndMovers: 667,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 312,
        truckAndMovers: 444,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 297,
        truckAndMovers: 577,
      },
    },
  },
  LOUISVILLE_KY: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 247,
        truckAndMovers: 624,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 255,
        truckAndMovers: 405,
      },
    },
    HOME: {
      '2BR+': {
        movers: 372,
        truckAndMovers: 701,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 198,
        truckAndMovers: 433,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 247,
        truckAndMovers: 516,
      },
    },
  },
  KY: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 247,
        truckAndMovers: 624,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 255,
        truckAndMovers: 405,
      },
    },
    HOME: {
      '2BR+': {
        movers: 372,
        truckAndMovers: 701,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 198,
        truckAndMovers: 433,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 247,
        truckAndMovers: 516,
      },
    },
  },
  MEMPHIS_TN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 230,
        truckAndMovers: 689,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 236,
        truckAndMovers: 472,
      },
    },
    HOME: {
      '2BR+': {
        movers: 273,
        truckAndMovers: 721,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 537,
      },
      'Studio - 1BR': {
        movers: 447,
        truckAndMovers: 805,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 596,
        truckAndMovers: 664,
      },
    },
  },
  MIAMI_FL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 273,
        truckAndMovers: 714,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 270,
        truckAndMovers: 641,
      },
    },
    HOME: {
      '2BR+': {
        movers: 292,
        truckAndMovers: 767,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 567,
      },
      'Studio - 1BR': {
        movers: 318,
        truckAndMovers: 614,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 693,
      },
    },
  },
  MINNEAPOLIS_MN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 324,
        truckAndMovers: 759,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 507,
      },
      'Studio - 1BR': {
        movers: 350,
        truckAndMovers: 605,
      },
    },
    HOME: {
      '2BR+': {
        movers: 334,
        truckAndMovers: 944,
      },
      'Few items': {
        movers: 278,
      },
      'Studio - 1BR': {
        movers: 417,
        truckAndMovers: 507,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 347,
        truckAndMovers: 572,
      },
    },
  },
  MN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 324,
        truckAndMovers: 759,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 507,
      },
      'Studio - 1BR': {
        movers: 350,
        truckAndMovers: 605,
      },
    },
    HOME: {
      '2BR+': {
        movers: 334,
        truckAndMovers: 944,
      },
      'Few items': {
        movers: 278,
      },
      'Studio - 1BR': {
        movers: 417,
        truckAndMovers: 507,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 347,
        truckAndMovers: 572,
      },
    },
  },
  NASHVILLE_TN: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 278,
        truckAndMovers: 628,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 289,
        truckAndMovers: 478,
      },
    },
    HOME: {
      '2BR+': {
        movers: 282,
        truckAndMovers: 762,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 280,
        truckAndMovers: 484,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 437,
        truckAndMovers: 631,
      },
    },
  },
  NEW_YORK_NY: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 241,
        truckAndMovers: 672,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 229,
        truckAndMovers: 616,
      },
    },
    HOME: {
      '2BR+': {
        movers: 350,
        truckAndMovers: 660,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 204,
        truckAndMovers: 546,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 207,
        truckAndMovers: 405,
      },
    },
  },
  NY: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 241,
        truckAndMovers: 672,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 229,
        truckAndMovers: 616,
      },
    },
    HOME: {
      '2BR+': {
        movers: 350,
        truckAndMovers: 660,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 204,
        truckAndMovers: 546,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 207,
        truckAndMovers: 405,
      },
    },
  },
  OMAHA_NE: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 305,
        truckAndMovers: 626,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 314,
        truckAndMovers: 592,
      },
    },
    HOME: {
      '2BR+': {
        movers: 377,
        truckAndMovers: 775,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 895,
      },
      'Studio - 1BR': {
        movers: 218,
        truckAndMovers: 417,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 218,
        truckAndMovers: 716,
      },
    },
  },
  NE: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 305,
        truckAndMovers: 626,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 314,
        truckAndMovers: 592,
      },
    },
    HOME: {
      '2BR+': {
        movers: 377,
        truckAndMovers: 775,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 895,
      },
      'Studio - 1BR': {
        movers: 218,
        truckAndMovers: 417,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 218,
        truckAndMovers: 716,
      },
    },
  },
  ORLANDO_FL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 289,
        truckAndMovers: 675,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 277,
        truckAndMovers: 531,
      },
    },
    HOME: {
      '2BR+': {
        movers: 399,
        truckAndMovers: 824,
      },
      'Few items': {
        movers: 636,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 386,
        truckAndMovers: 501,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 357,
        truckAndMovers: 680,
      },
    },
  },
  PHILADELPHIA_PA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 458,
        truckAndMovers: 805,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 314,
        truckAndMovers: 702,
      },
    },
    HOME: {
      '2BR+': {
        movers: 337,
        truckAndMovers: 890,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 306,
        truckAndMovers: 576,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 507,
        truckAndMovers: 678,
      },
    },
  },
  PA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 458,
        truckAndMovers: 805,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 314,
        truckAndMovers: 702,
      },
    },
    HOME: {
      '2BR+': {
        movers: 337,
        truckAndMovers: 890,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 306,
        truckAndMovers: 576,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 507,
        truckAndMovers: 678,
      },
    },
  },
  PHOENIX_AZ: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 280,
        truckAndMovers: 622,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 230,
        truckAndMovers: 450,
      },
    },
    HOME: {
      '2BR+': {
        movers: 417,
        truckAndMovers: 761,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 274,
        truckAndMovers: 467,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 231,
        truckAndMovers: 637,
      },
    },
  },
  AZ: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 280,
        truckAndMovers: 622,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 230,
        truckAndMovers: 450,
      },
    },
    HOME: {
      '2BR+': {
        movers: 417,
        truckAndMovers: 761,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 274,
        truckAndMovers: 467,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 231,
        truckAndMovers: 637,
      },
    },
  },
  PITTSBURGH_PA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 211,
        truckAndMovers: 634,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 214,
        truckAndMovers: 565,
      },
    },
    HOME: {
      '2BR+': {
        movers: 223,
        truckAndMovers: 720,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 215,
        truckAndMovers: 417,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 301,
        truckAndMovers: 587,
      },
    },
  },
  PORTLAND_OR: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 482,
        truckAndMovers: 806,
      },
      'Few items': {
        movers: 338,
        truckAndMovers: 537,
      },
      'Studio - 1BR': {
        movers: 401,
        truckAndMovers: 664,
      },
    },
    HOME: {
      '2BR+': {
        movers: 432,
        truckAndMovers: 950,
      },
      'Few items': {
        movers: 338,
        truckAndMovers: 537,
      },
      'Studio - 1BR': {
        movers: 450,
        truckAndMovers: 596,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 627,
        truckAndMovers: 821,
      },
    },
  },
  OR: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 482,
        truckAndMovers: 806,
      },
      'Few items': {
        movers: 338,
        truckAndMovers: 537,
      },
      'Studio - 1BR': {
        movers: 401,
        truckAndMovers: 664,
      },
    },
    HOME: {
      '2BR+': {
        movers: 432,
        truckAndMovers: 950,
      },
      'Few items': {
        movers: 338,
        truckAndMovers: 537,
      },
      'Studio - 1BR': {
        movers: 450,
        truckAndMovers: 596,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 627,
        truckAndMovers: 821,
      },
    },
  },
  'RALEIGH-DURHAM-CHAPEL-HILL_NC': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 221,
        truckAndMovers: 582,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 222,
        truckAndMovers: 398,
      },
    },
    HOME: {
      '2BR+': {
        movers: 231,
        truckAndMovers: 673,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 226,
        truckAndMovers: 412,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 247,
        truckAndMovers: 550,
      },
    },
  },
  RICHMOND_VA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 232,
        truckAndMovers: 663,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 252,
        truckAndMovers: 459,
      },
    },
    HOME: {
      '2BR+': {
        movers: 367,
        truckAndMovers: 755,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 313,
        truckAndMovers: 473,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 247,
        truckAndMovers: 662,
      },
    },
  },
  VA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 232,
        truckAndMovers: 663,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 252,
        truckAndMovers: 459,
      },
    },
    HOME: {
      '2BR+': {
        movers: 367,
        truckAndMovers: 755,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 313,
        truckAndMovers: 473,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 247,
        truckAndMovers: 662,
      },
    },
  },
  SAINT_LOUIS_MO: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 297,
        truckAndMovers: 706,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 292,
        truckAndMovers: 530,
      },
    },
    HOME: {
      '2BR+': {
        movers: 299,
        truckAndMovers: 853,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 285,
        truckAndMovers: 542,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 321,
        truckAndMovers: 522,
      },
    },
  },
  SAN_ANTONIO_TX: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 244,
        truckAndMovers: 663,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 258,
        truckAndMovers: 473,
      },
    },
    HOME: {
      '2BR+': {
        movers: 261,
        truckAndMovers: 761,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 198,
        truckAndMovers: 451,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 357,
        truckAndMovers: 697,
      },
    },
  },
  'SAN JOSE_CA': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 245,
        truckAndMovers: 626,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 299,
        truckAndMovers: 579,
      },
    },
    HOME: {
      '2BR+': {
        movers: 274,
        truckAndMovers: 775,
      },
      'Few items': {
        movers: 218,
        truckAndMovers: 417,
      },
      'Studio - 1BR': {
        movers: 486,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 218,
        truckAndMovers: 626,
      },
    },
  },
  SEATTLE_WA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 249,
        truckAndMovers: 700,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 247,
        truckAndMovers: 582,
      },
    },
    HOME: {
      '2BR+': {
        movers: 230,
        truckAndMovers: 754,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 231,
        truckAndMovers: 619,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 509,
        truckAndMovers: 619,
      },
    },
  },
  WA: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 249,
        truckAndMovers: 700,
      },
      'Few items': {
        movers: 198,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 247,
        truckAndMovers: 582,
      },
    },
    HOME: {
      '2BR+': {
        movers: 230,
        truckAndMovers: 754,
      },
      'Few items': {
        movers: 278,
        truckAndMovers: 387,
      },
      'Studio - 1BR': {
        movers: 231,
        truckAndMovers: 619,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 509,
        truckAndMovers: 619,
      },
    },
  },
  TAMPA_FL: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 325,
        truckAndMovers: 760,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 317,
        truckAndMovers: 566,
      },
    },
    HOME: {
      '2BR+': {
        movers: 344,
        truckAndMovers: 853,
      },
      'Few items': {
        movers: 258,
        truckAndMovers: 477,
      },
      'Studio - 1BR': {
        movers: 338,
        truckAndMovers: 530,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 290,
        truckAndMovers: 556,
      },
    },
  },
  TUCSON_AZ: {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 357,
        truckAndMovers: 831,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 285,
        truckAndMovers: 536,
      },
    },
    HOME: {
      '2BR+': {
        movers: 445,
        truckAndMovers: 810,
      },
      'Few items': {
        movers: 238,
        truckAndMovers: 447,
      },
      'Studio - 1BR': {
        movers: 238,
        truckAndMovers: 661,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 357,
        truckAndMovers: 630,
      },
    },
  },
  'WASHINGTON D.C._DC': {
    'APARTMENT/CONDO': {
      '2BR+': {
        movers: 223,
        truckAndMovers: 646,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 230,
        truckAndMovers: 570,
      },
    },
    HOME: {
      '2BR+': {
        movers: 217,
        truckAndMovers: 703,
      },
      'Few items': {
        movers: 178,
        truckAndMovers: 357,
      },
      'Studio - 1BR': {
        movers: 239,
        truckAndMovers: 409,
      },
    },
    OTHER: {
      '1-1000 SQFT': {
        movers: 237,
        truckAndMovers: 561,
      },
    },
  },
};
